import styled from "styled-components";
import type { HTTPURL } from "@bracket/types";
import { ExternalLinkIcon, Icon, type IconName, } from "@bracket/ui";

export declare type LogoLinkProps = {
	url?: HTTPURL;
	image?: HTTPURL;
	icon?: IconName;
	iconSize?: string;
	height?: string;
};

export const LogoLink = ({ url, image, icon, iconSize, height, }: LogoLinkProps) => {
	return (
		<LogoLinkBrace $height={height}>
			{ url && <Image src={image} alt="logo" /> }
			{ icon && <Icon icon={icon} size={iconSize} /> }
			<a href={url} target="_blank" rel="noopener noreferrer"><ExternalLinkIcon /></a>
		</LogoLinkBrace>
	);
};

const LogoLinkBrace = styled.div<{ $height?: string; }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	height: ${({ $height }) => $height || "auto"};
	a {
		color: white;
	}
`;

const Image = styled.img<{ $height?: string; }>`
	height: 100%;
`;
